import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Plan } from "./plan.interface";
import { environment } from "../../environments/environment";
import { FinanceSettings } from "../finance/finance.interface";

declare const Stripe: (key: string) => unknown;

@Injectable({
  providedIn: "root",
})
export class PlanService {
  stripe: {
    redirectToCheckout: (options: { sessionId: string }) => Promise<void>;
  };

  constructor(private http: HttpClient) {
    this.stripe = Stripe(environment.stripeKey) as {
      redirectToCheckout: (options: { sessionId: string }) => Promise<void>;
    };
  }

  getAll = () => this.http.get<Plan[]>("/plan");
  buy = (priceId: string): Observable<{ id: string }> =>
    this.http.post<{ id: string }>("/plan/checkout", { priceId });
  settings = () => this.http.post<FinanceSettings>("/plan/settings", {});

  redirectToCheckout = (sessionId: string) =>
    this.stripe.redirectToCheckout({ sessionId });
}
